import { PlaceApiPlaceListRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseQuery from "./useBaseQuery";

export const usePlaceListQuery = (req: PlaceApiPlaceListRequest) =>
  useBaseQuery({
    queryKey: ["placeList", req],
    queryFn: (config) => appApiClient.placeApi.placeList(req, config),
  });
